import { useSelector } from "react-redux";

/**
 * Quick alias for Redux selectors
 * @param selectFn
 */
export const useAppState = (selectFn) => useSelector(selectFn);
